import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const updateExceptionStatus = createApi(`UpdateExceptionStatusSlice`, "POST");

const UpdateExceptionStatusSlice = createSlice({
  name: 'UpdateExceptionStatusSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateExceptionStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateExceptionStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateExceptionStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default UpdateExceptionStatusSlice.reducer;
